import React from "react";

import { Container } from "./styles";

export default function Footer() {
	function handleTop() {
		document.querySelector("main").scrollIntoView({ behavior: "smooth" });
	}

	return (
		<Container id='footer'>
			<div className='container-fluid'>
				<div className='row justify-content-lg-center'>
					<div className='col-12 col-lg-11'>
						<div className='footer'>
							<div className='footer__header'>
								<div className='separator-right'>
									<img
										className='img-responsive'
										srcSet={`${require("../../assets/img/logo-labyes.png")
											.default
											} 320w, 
                                                ${require("../../assets/img/logo-labyes@2x.png")
												.default
											} 480w, 
                                                ${require("../../assets/img/logo-labyes@3x.png")
												.default
											} 800w`}
										src={
											require("../../assets/img/logo-labyes.png")
												.default
										}
										alt='labyes'
										loading='lazy'
									/>
								</div>

								<div className='social-midia'>
									<a
										href={
											process.env.REACT_APP_URL_FACEBOOK
										}
										target='_blank'
										rel='noopener noreferrer'>
										<img
											className='img-responsive'
											src={
												require("../../assets/img/facebook.jpg")
													.default
											}
											alt='facebook'
											loading='lazy'
										/>
									</a>
									<a
										href={
											process.env.REACT_APP_URL_INSTAGRAM
										}
										target='_blank'
										rel='noopener noreferrer'>
										<img
											className='img-responsive ml-2'
											src={
												require("../../assets/img/instagram.jpg")
													.default
											}
											alt='instagram'
											loading='lazy'
										/>
									</a>
									<a
										href={process.env.REACT_APP_URL_YOUTUBE}
										target='_blank'
										rel='noopener noreferrer'>
										<img
											className='img-responsive ml-2'
											src={
												require("../../assets/img/youtube.jpg")
													.default
											}
											alt='youtube'
											loading='lazy'
										/>
									</a>
								</div>
							</div>

							<div className='footer__copy'>
								<p className='copyright'>
									Todos os direitos
									reservados. <a href="https://labyes.com/pt-br/termos-e-condicoes/" target="_blank" rel="noreferrer">Termos e Condições</a> &#38;
									{" "}<a href="https://labyes.com/pt-br/politica-de-privacidade/" target="_blank" rel="noreferrer">Politica de Privacidade</a>
								</p>

								<button className='btn-top' onClick={handleTop}>
									<img
										className='go-top'
										src={
											require("../../assets/img/top.png")
												.default
										}
										alt='scroll-top'
										loading='lazy'
									/>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Container>
	);
}
